import * as z from 'zod';

export const loginFormSchema = z.object({
  email: z.string()
    .email('Email không hợp lệ')
    .min(1, 'Email là bắt buộc'),
  password: z.string()
    .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
    .min(1, 'Mật khẩu là bắt buộc'),
  rememberMe: z.boolean().default(false),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>; 